import React, { useEffect, useMemo } from "react"
import { FormattedMessage } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import { Creatable } from "react-select"
import { clearSerialNumberListing, fetchSerialNumberListing } from "../../../state/listing/serial-numbers/actions"
import { productSerialNumbersSelector } from "../../../state/listing/serial-numbers/selectors"
import Icon from "../../icon/icon.component"
import { SelectOption, SerialNumberSelectProps } from "../../types"

const SerialNumberSelect = (props: SerialNumberSelectProps) => {
    if (!props.productID) return <></>

    const productSerialNumbers = useSelector(productSerialNumbersSelector)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchSerialNumberListing({
            productId: props.productID,
        }))

        return () => {
            dispatch(clearSerialNumberListing())
        }
    }, [])

    const maxNumberOfSerialNumbersSurpassed = props.selection.length > props.maxNumberOfSerialNumbers
    if (maxNumberOfSerialNumbersSurpassed) {
        props.onChange(props.selection.slice(0, props.maxNumberOfSerialNumbers))
    }

    const handleChange = (selection: SelectOption<string>[]) => {
        if (selection.length > props.maxNumberOfSerialNumbers) return
        props.onChange(selection.map((item) => item.value))
    }

    const options: Array<SelectOption<string>> = useMemo(() =>
        productSerialNumbers.map((item) => ({
            label: item.serial,
            value: item.serial,
        })),
    [productSerialNumbers.length])

    const values = props.selection.map((item) => ({
        label: item,
        value: item,
    }))

    return <Creatable
        multi={true}
        value={values}
        onChange={handleChange}
        options={options}
        disabled={props.isDisabled}
        promptTextCreator={userInput =>
            <span className="text-primary">
                <Icon value={"layer-group"} className={"mr-1"}/>
                <small>
                    <FormattedMessage
                        id="pricing.components.serialNumberSelect.create_serial_number"
                        defaultMessage="Create / Add {number}"
                        values={{
                            number: userInput,
                        }}
                    />
                </small>
            </span>
        }
    >
    </Creatable>
}

export default SerialNumberSelect


// WEBPACK FOOTER //
// ./src/common/pricing/components/SerialNumberSelect.tsx